// Import enums directly for value access
import { AreaCode as AreaCodeEnum } from '@enechain/eposition-proto/bfftypes/v1/area_pb'
import { DealPosition as DealPositionEnum } from '@enechain/eposition-proto/bfftypes/v1/deal_pb'

/**
 * Deal report CSV generation types
 */

// Re-export proto-generated types for easier imports
export type {
  ListOrganizationDealPerFrameResponse,
  ListOrganizationDealPerFrameResponse_DealPerFrame as DealPerFrame,
} from '@enechain/eposition-proto/bffportal/v1/report_service_pb'

export type { FrameKwh } from '@enechain/eposition-proto/bffportal/v1/report_model_pb'

export { AreaCodeEnum as AreaCode, DealPositionEnum as DealPosition }

/**
 * Deal report CSV row type with English keys
 */
export type DealReportCsvRow = {
  date: string // YYYY-MM-DD
  frame: number // 1-48
  timeFrom: string // HH:MM:SS
  timeTo: string // HH:MM:SS
  hokkaidoBid: number // 北海道買(kWh)
  hokkaidoOffer: number // 北海道売(kWh)
  tohokuBid: number // 東北買(kWh)
  tohokuOffer: number // 東北売(kWh)
  tokyoBid: number // 東京買(kWh)
  tokyoOffer: number // 東京売(kWh)
  chubuBid: number // 中部買(kWh)
  chubuOffer: number // 中部売(kWh)
  hokurikuBid: number // 北陸買(kWh)
  hokurikuOffer: number // 北陸売(kWh)
  kansaiBid: number // 関西買(kWh)
  kansaiOffer: number // 関西売(kWh)
  chugokuBid: number // 中国買(kWh)
  chugokuOffer: number // 中国売(kWh)
  shikokuBid: number // 四国買(kWh)
  shikokuOffer: number // 四国売(kWh)
  kyushuBid: number // 九州買(kWh)
  kyushuOffer: number // 九州売(kWh)
}

/**
 * CSV download options
 */
export type CsvDownloadOptions = {
  filename: string
  encoding?: 'utf-8-bom' | 'utf-8'
}

/**
 * Area code to label mapping for English keys
 */
export const AREA_CODE_TO_KEY: Record<AreaCodeEnum, string> = {
  [AreaCodeEnum.UNSPECIFIED]: '',
  [AreaCodeEnum.HOKKAIDO]: 'hokkaido',
  [AreaCodeEnum.TOHOKU]: 'tohoku',
  [AreaCodeEnum.TOKYO]: 'tokyo',
  [AreaCodeEnum.CHUBU]: 'chubu',
  [AreaCodeEnum.HOKURIKU]: 'hokuriku',
  [AreaCodeEnum.KANSAI]: 'kansai',
  [AreaCodeEnum.CHUGOKU]: 'chugoku',
  [AreaCodeEnum.SHIKOKU]: 'shikoku',
  [AreaCodeEnum.KYUSHU]: 'kyushu',
}

/**
 * Deal position to label mapping for English keys
 */
export const DEAL_POSITION_TO_KEY: Record<DealPositionEnum, string> = {
  [DealPositionEnum.UNSPECIFIED]: '',
  [DealPositionEnum.BID]: 'Bid',
  [DealPositionEnum.OFFER]: 'Offer',
}

/**
 * CSV column order (matches existing format requirement)
 */
export const CSV_COLUMN_ORDER: Array<keyof DealReportCsvRow> = [
  'date',
  'frame',
  'timeFrom',
  'timeTo',
  'hokkaidoBid',
  'hokkaidoOffer',
  'tohokuBid',
  'tohokuOffer',
  'tokyoBid',
  'tokyoOffer',
  'chubuBid',
  'chubuOffer',
  'hokurikuBid',
  'hokurikuOffer',
  'kansaiBid',
  'kansaiOffer',
  'chugokuBid',
  'chugokuOffer',
  'shikokuBid',
  'shikokuOffer',
  'kyushuBid',
  'kyushuOffer',
] as const

/**
 * Frame configuration (assumed values - to be confirmed)
 */
export const FRAME_CONFIG = {
  /** Total frames per day */
  TOTAL_FRAMES: 48,
  /** Frame start number */
  FRAME_START: 1,
  /** Minutes per frame */
  FRAME_MINUTES: 30,
} as const

export type ContractCsvRow = {
  dealtDate: string
  platformName: string
  eclearDealCode: string
  dealPosition: string
  areaCode: string
  // 差額精算対象エリア。クロスエリア取引でのみ埋まり、通常は空文字
  settlementDifferenceTargetArea: string
  deliveryStartDate: string
  deliveryEndDate: string
  deliveryTypeString: string
  deliveryHourType: string
  volumeInKw: string
  totalDeliveryHour: string
  totalKwh: string
  unitPricePerKwh: string
  floatingIndexFormula: string
  currentMarketPrice: string
  mtm: string
  clearingFeeRate: string
  fee: string
}
